"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _SIAPageTop = _interopRequireDefault(require("../SIAPage/SIAPageTop/SIAPageTop"));
var _LegalPolicyArticle = _interopRequireDefault(require("../LegalPolicyArticle/LegalPolicyArticle"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
(function () {
  const styles = ":export {\n  primary-SIAblack: #000000;\n  primary-SIAgraydark: #4c4c4c;\n  primary-SIAgrayMiddle: #a8a8a8;\n  primary-SIAgray: #d4d4d4;\n  primary-SIAgrayLight: #e8e8e8;\n  primary-SIAgrayVeryLight: #f4f4f4;\n  primary-SIAwhite: #fff;\n  primary-SIAred: #e41b13;\n  primary-SIAredDark: #99100a;\n  secondary-SIAazure: #8caddb;\n  secondary-SIAazureLight: #e9eff7;\n  secondary-SIAbronze: #b1997e;\n  secondary-SIAbronzeLight: #efebe5;\n  secondary-SIAgreen: #2fb789;\n  secondary-SIAgreenLight: #ecf7f3;\n  secondary-SIAorange: #f3743d;\n  secondary-SIAorangeLight: #fbf1ec;\n  secondary-SIArose: #e6005f;\n  secondary-SIAroseLight: #fcf2f7;\n  secondary-SIAyellow: #dacd7e;\n  secondary-SIAyellowLight: #faf8ed; }\n\n.sia-legalpolicy {\n  display: flex;\n  flex-direction: column; }\n  .sia-legalpolicy .accordion-container,\n  .sia-legalpolicy .link {\n    width: 764px;\n    max-width: 100%;\n    align-self: center; }\n  @media (max-width: 42rem) {\n    .sia-legalpolicy .accordion-container .bx--accordion__heading {\n      justify-content: space-between; }\n    .sia-legalpolicy .accordion-container .bx--accordion__title {\n      text-overflow: ellipsis;\n      overflow: hidden;\n      white-space: nowrap;\n      padding-right: 4px;\n      max-width: 372px; } }\n";
  const fileName = "SIALegalPolicy_SIALegalPolicy";
  const element = document.querySelector("style[data-sass-component='SIALegalPolicy_SIALegalPolicy']");
  if (!element) {
    const styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();
const SIALegalPolicy = _ref => {
  let {
    item,
    lang,
    translate,
    history
  } = _ref;
  const pdfPath = item.pdf_link && item.pdf_link[0] && item.pdf_link[0][0]?.url;
  const date = item.validity_date && item.validity_date[0].split('-');
  const validityDate = date && `${date[2]}.${date[1]}.${date[0]}`;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "sia-legalpolicy"
  }, /*#__PURE__*/_react.default.createElement(_SIAPageTop.default, {
    title: item.title,
    lead: item.page_lead,
    lang: lang
  }), (date || pdfPath) && /*#__PURE__*/_react.default.createElement("div", {
    className: "link sia-padding-05-bottom"
  }, date && /*#__PURE__*/_react.default.createElement("span", {
    className: "sia-text-11"
  }, translate('cms.legal-policy.date'), " ", validityDate, ' ', pdfPath ? '|' : ''), pdfPath && /*#__PURE__*/_react.default.createElement("a", {
    href: pdfPath,
    target: "_blank",
    className: "sia-margin-01-left"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "sia-text-10"
  }, translate('cms.legal-policy.pdf')))), /*#__PURE__*/_react.default.createElement("div", {
    className: "accordion-container"
  }, /*#__PURE__*/_react.default.createElement(_LegalPolicyArticle.default, {
    article: item.article,
    lang: lang,
    history: history
  })));
};
SIALegalPolicy.propTypes = {
  item: _propTypes.default.object.isRequired
};
var _default = exports.default = SIALegalPolicy;